import React from 'react';
const EmptyData = (props) => {
  return (<div>
    <img style={{
      display: "block",
      margin: "auto"
    }}
      width="64px"
      src="/img/opened-white-box.png" />
    <p style={{ textAlign: "center", color: "darkgrey" }}> {"No Clients"} </p>
  </div>);
};

export default EmptyData;


// WEBPACK FOOTER //
// ./src/components/EmptyData/EmptyData.js